export const ALL_APP_LOCALES = [
  "en",
  "ru",
  "ar",
  "es",
  "fr",
  "he",
  "de",
  "pt-br",
  "ja",
  "hi",
  "id",
  "zh-cn",
  "tr",
  "ko",
  "it",
] as const;

export type AppLocale = (typeof ALL_APP_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = "en";

export const RTL_LOCALES: readonly AppLocale[] = ["ar", "he"];
